import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let loadPromise = null;

function mapsReady() {
  return !!(
    window.google?.maps?.places &&
    typeof window.google.maps.Map === 'function'
  );
}

/**
 * Loads the Maps JavaScript API (maps, places, routes, geocoding) once per session.
 * Required for AddressAutocomplete, live GPS map, and distance matrix usage.
 */
export function loadGoogleMaps() {
  if (!apiKey?.trim()) {
    return Promise.reject(new Error('REACT_APP_GOOGLE_MAPS_API_KEY is missing'));
  }
  if (mapsReady()) {
    return Promise.resolve();
  }
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = (async () => {
    setOptions({ key: apiKey.trim(), v: 'weekly' });
    await importLibrary('maps');
    await importLibrary('places');
    await importLibrary('geocoding');
    try {
      await importLibrary('geometry');
    } catch {
      // Polyline decode fallback uses step paths when geometry is unavailable.
    }
    try {
      await importLibrary('routes');
    } catch {
      // Distance Matrix lives in routes; Haversine fallback still works if this fails.
    }
  })().catch((err) => {
    loadPromise = null;
    throw err;
  });

  return loadPromise;
}
